<template>
  <div>
    <service-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :productType="productType"
      :titleObj = "titleObj"
    >
    </service-header>
    <service-center></service-center>
    <service-footer
      :bottomNews="bottomNews"
      :bottom="bottom"
      :bottomInfo="bottomInfo"
      :productType="productType"
    >
    </service-footer>
  </div>
</template>
<script>
import ServiceHeader from '@/components/pc/Header'
import ServiceCenter from '@/components/pc/ServiceCenter'
import ServiceFooter from '@/components/pc/Footer'
export default {
  name: "Service",
  data() {
    return {
      screenStyle: {
        width: '',
        margin: "0 auto",
      },
      topStyle: "",
      actIndex: 5,
      imgList: [],
      logo: '',
      productType: [],
      bottom: {},
      bottomInfo: {},
      bottomNews: [],
      // background: require("../../static/images/service/banner.png"),
      titleObj:{},
    }
  },
  components: {
    ServiceHeader,
    ServiceCenter,
    ServiceFooter,
  },
  mounted() {
    this.Pc_Mobile();
    this.getPageData();
    this.getHeaderImage();
    this.titleObj = { title: '服务中心', desc: '从软件开发到交付\n全程为客户提供优质化服务' };

  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push('/m_service');
      } else {
        this.$router.push('/service');
      }
    },
    getPageData() {
      this.$http.post('home/index/product', null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0]
        this.logo = this.bottom.logo
        // this.topStyle = "background-image:url('" + this.background + "')"
        this.bottomInfo = res.data.contact[0]
        this.productType = res.data.type
        this.productAll = res.data.product
        this.bottomNews = res.data.b_news
      })
    },
        getHeaderImage() {
      this.$http.post("https://eartisanapplets.wsandos.com/api/index/special", {type_two:5}, (res) => {
        if (res.code == 1) {
          this.topStyle =
            "background-image:url('" + res.data.pc_image + "')";
        }
      });
    },
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/pc/Service.vue